
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { pdfStore } from '@/store'
import PDFPreview from '@/components/pdfs/PDFPreview.vue'
import PDFFrontpage from '@/components/pdfs/sections/general/PDFFrontpage.vue'
import PDFSamples from '@/components/pdfs/sections/general/PDFSamples.vue'

export default defineComponent({
  name: 'SamplesDocument',
  props: {
    reference: {
      type: String,
      default: '',
    },
    initFetch: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(pdfStore, ['configs']),
    key() {
      return this.reference || this.$route.query.reference
    },
    pdf() {
      const reference =
        this.reference || (this.$route.query.reference as string)

      return reference
        ? this.configs.documents[reference]
        : this.configs.documents.samplesDocument
    },
    initiatePDFRequest() {
      // 1. Ensure fetch is requested && pdf have been loaded in DOM
      return this.initFetch
    },
  },
  watch: {
    initFetch: {
      handler(bool) {
        // Mimic the initial process from PDFPreview when the DOM is building
        if (bool) {
          this.statusChanged('process:creating-pdf')
        }
      },
      immediate: true,
    },
  },
  methods: {
    statusChanged(str: string) {
      this.$emit('status-changed', {
        reportType: this.pdf.reference,
        status: str,
      })
    },
  },
  components: {
    PDFPreview,
    PDFFrontpage,
    PDFSamples,
  },
})
